module.exports = " <div > <img src=\"/assets/image/error404.png\" style=\"height:100%; width:100%\"></div>"


//////////////////
// WEBPACK FOOTER
// /Users/hrushabhmakwana/Documents/CAM/CreditRepairMenAngular/src/app/common/components/page-not-found/page-not-found.component.html
// module id = ../../../../../src/app/common/components/page-not-found/page-not-found.component.html
// module chunks = main